import { schema } from 'normalizr';

import { processUser } from '../strategies/user';

import { networkSchema } from './network';
import { originNetworkSchema } from './originNetwork';
import { userHideFieldSchema } from './userHideField';

export const userSchema = new schema.Entity(
  'users',
  {
    networkId: networkSchema,
    originNetwork: originNetworkSchema,
    userHideField: userHideFieldSchema,
  },
  {
    processStrategy: processUser,
  }
);
